import styled from 'styled-components';

export const ManagePivDrawerStyles = styled.div`
	height: 100%;

	.piv-box {
		min-height: 114px;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		border-radius: 0.25rem;
		background: ${({ theme }) => theme.v3.colors.gray[0]};
		padding: 0.5rem;

		&-hidden {
			> * {
				opacity: 0;
			}
		}
	}

	.current-pill {
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 1rem;
		padding: 0.25rem 0.5rem;
	}

	.piv-warning {
		margin-bottom: 1rem;
	}
`;
